import { render } from "./ShowKonsultasi.vue?vue&type=template&id=e440c65e&scoped=true"
import script from "./ShowKonsultasi.vue?vue&type=script&lang=js"
export * from "./ShowKonsultasi.vue?vue&type=script&lang=js"

import "./ShowKonsultasi.vue?vue&type=style&index=0&id=e440c65e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e440c65e"]])

export default __exports__